// test622
(622 && 0);
